var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.serienumero.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.serienumero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serienumero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.serienumero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.equipo.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.equipo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.equipo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.equipo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.ubicacion.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.ubicacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.ubicacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.ubicacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.cantidad_activadores.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.cantidad_activadores.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidad_activadores,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidad_activadores.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.compra_numero.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.compra_numero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.compra_numero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.compra_numero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.imei.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.imei.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.imei, "value", $$v)
                                  },
                                  expression: "formFields.imei.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.fecha_bateria.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fecha_bateria.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fecha_bateria,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fecha_bateria.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }